import styled from 'styled-components'

export const Content = styled.div`
  margin-top: 1rem;
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
  color: ${({ theme }) => theme.colors.text.primary};
  margin-bottom: 1.5rem;
`

export const LineDescription = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`
